import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Panel, Row, Col } from 'react-bootstrap';
import { Switch, Route, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import FeedbacksTable from './FeedbacksTable';
import ViewsMenu from './ViewsMenu';
import Analytics from './Analytics';

@inject('authorizationsStore')
export default class Index extends React.Component {
  render() {
    return (
      <Panel className={'border-top border-top-2'}>
        <Row>
          <Col xs={12} md={3}>
            <ViewsMenu />
          </Col>
          <Col xs={12} md={9}>
            <Switch>
              <Route
                path="/:locale?/gstartup/:id/igsupport/analytics"
                render={props => {
                  if (this.props.authorizationsStore.canSeeAnalytics()) {
                    return <Analytics />;
                  }
                  return null;
                }}
              />
              <Route
                render={props => {
                  return <FeedbacksTable />;
                }}
              />
            </Switch>
          </Col>
        </Row>
      </Panel>
    );
  }
}
